/**
 * FAQ Section — Accordion Interaction
 * oddit-section-faq
 */
(function () {
  function initFaqSection(sectionEl) {
    if (!sectionEl) return;

    var triggers = sectionEl.querySelectorAll('.oddit-section-faq__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        var answer = trigger.nextElementSibling;

        // Close all other items
        triggers.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
            var otherAnswer = otherTrigger.nextElementSibling;
            if (otherAnswer) {
              otherAnswer.classList.remove('oddit-section-faq__answer--open');
              otherAnswer.setAttribute('hidden', '');
            }
          }
        });

        // Toggle current item
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          if (answer) {
            answer.classList.remove('oddit-section-faq__answer--open');
            // Delay hiding to allow transition
            setTimeout(function () {
              answer.setAttribute('hidden', '');
            }, 300);
          }
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          if (answer) {
            answer.removeAttribute('hidden');
            // Force reflow before adding class for transition
            void answer.offsetHeight;
            answer.classList.add('oddit-section-faq__answer--open');
          }
        }
      });
    });
  }

  // Initialize all FAQ sections on the page
  var sections = document.querySelectorAll('.oddit-section-faq');
  sections.forEach(function (sectionEl) {
    initFaqSection(sectionEl);
  });

  // Theme editor support
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oddit-section-faq');
      if (section) {
        initFaqSection(section);
      }
    });
  }
})();